import { useState } from "react";
import IconTextButton from "../../../components/iconTextButton/IconTextButton"
import { SizedTextDataInput } from "../../../components/textDataInput/TextDataInput";
import { IWorksSearchQuery } from "../../../types/IWorksSearchQuery";
import { CHECKBOX_INPUT, DONOTCARE_ABOUTWORKFLOWS, HASOPEN_WORKFLOWS, READ_ONLY_INPUT, REPERTOIRE, SEARCH_VIEW_HAS_OPEN_WORKFLOW, SEARCH_VIEW_WORKS, WITHOUTOPEN_WORKFLOWS, INTRAY } from "../../../Consts";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IMembersPortalStateKeys } from "../../../../membersportal/types/IMembersPortalStateKeys";
import IAppState from "../../../../redux/types/IAppState";
import { searchWorksThunk, updateUserPreferencesThunk } from "../../../../redux/thunks/RepertoireThunks";
import { connect } from "react-redux";
import ActionButton from "../../../components/actionButton/ActionButton";
import { IRepertoireField } from "../../../types/IRepertoireField";
import SelectionTable from "../../../components/selectionTable/SelectionTable";
import { expandAllResults, expandWorkResult, updateMatchingWork, updatePagination, resetPagination } from "../../../../redux/reducers/RepertoireReducer";
import { IWorksSearchResult } from "../../../types/IWorksSearchResult";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { ComponentsHelper } from "../../../../core/services/ComponentHelper";
import { SizedRadiobuttonDataInput } from "../../../components/radioButtonDataInput/RadiobuttonDataInput";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { Search20Regular } from "@fluentui/react-icons";

const MatchingRepertoireWorksSearchSection = ({
    searchWorks,
    searchViewData,
    searchSuccessful,
    worksSearchResults,
    expandedWorkResults,
    searchResultsTableData,
    updateMatchingWork,
    expandAll,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    updatePagination,
    hideModal,
    originWork,
    tableContentsForTheMatchingWorksTable,
    changeData,
    stateKey,
    openInSplitScreen,
    expandWorkResult,
    expandAllResults,
    resetPagination,
    lookupValues,
}) => {
    const [isWorkIntraySearchOpen, setIsWorkIntraySearchOpen] = useState(false);
    const [data, setData] = useState({
        title: originWork.originalTitle ? originWork.originalTitle : "",
        number: "",     
        artist: "",
        writers: originWork.contributors && originWork.contributors?.distribution && originWork.contributors?.distribution[0]?.name?.value ? originWork.contributors?.distribution[0]?.name?.value : '',
        societyAccountNumber: "",
        dataSource: REPERTOIRE,
        workBatchID: "",
        hasOpenWorkflow: null,
        workType: "",
    });
    const [isSearchExpandAllClicked, setIsSearchExpandAllClicked] = useState(false);

    const [expandedSearchResults, setExpandedSearchResults] = useState<number[]>([]);

    const handleSearchWorks = () => {
        let searchQuery: IWorksSearchQuery = {
            title: data.title,
            number: data.number,
            artist: data.artist,
            writers: data.writers,
            societyAccountNumber: data.societyAccountNumber,
            dataSource: data.dataSource,
            workBatchID: data.workBatchID,
            hasOpenWorkflow: data.hasOpenWorkflow,
            workType: data.workType,
            includeIsReplacedWorks: data.dataSource === REPERTOIRE ? true : false,
        };
        resetPagination(SEARCH_VIEW_WORKS);
        searchWorks(searchQuery, true, lookupValues);
    }



    const changeTextData = (value: string | boolean | number, fieldName: IRepertoireStateKeys | IMembersPortalStateKeys, isOnBlur?: boolean, index?: number) => {
        setData((prevState) => ({ ...prevState, [fieldName]: value }));
    }
    
    const handleExpandSearchResult = (workID: number) => {
        setExpandedSearchResults(prev =>
            prev.includes(workID) ? prev.filter(id => id !== workID) : [...prev, workID]
        );
    };

    const handleExpandAllSearchResults = () => {
        if (isSearchExpandAllClicked) {
            setExpandedSearchResults([]);
            setIsSearchExpandAllClicked(false);
        } else {
            setExpandedSearchResults(worksSearchResults.map(w => w.workID));
            setIsSearchExpandAllClicked(true);
        }
        expandAllResults();
    };





    const handleAddNewMatchingWork = (workID: number, work: IWorksSearchResult) => {
        updateMatchingWork(workID, work);
        const tableContentsCopy = [...tableContentsForTheMatchingWorksTable];

        const newItem = {
            workID: work.workID,
            repertoireWorkID: work.workID,
            name: [
                {
                    value: work.title[0] ? work.title[0] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.title[1] ? work.title[1] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.title[2] ? work.title[2] : "",
                    inputType: READ_ONLY_INPUT
                }
            ],
            number: [
                {
                    value: work.number[0] ? work.number[0] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.number[1] ? work.number[1] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.number[2] ? work.number[2] : "",
                    inputType: READ_ONLY_INPUT
                }
            ],
            publisher: [
                {
                    value: work.publishers[0] ? work.publishers[0] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.publishers[1] ? work.publishers[1] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.publishers[2] ? work.publishers[2] : "",
                    inputType: READ_ONLY_INPUT
                }
            ],
            writer: [
                {
                    value: work.writers[0] ? work.writers[0] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.writers[1] ? work.writers[1] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.writers[2] ? work.writers[2] : "",
                    inputType: READ_ONLY_INPUT
                }
            ],
            artist: [
                {
                    value: work.artists[0] ? work.artists[0] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.artists[1] ? work.artists[1] : "",
                    inputType: READ_ONLY_INPUT
                },
                {
                    value: work.artists[2] ? work.artists[2] : "",
                    inputType: READ_ONLY_INPUT
                }
            ],
            isDefinite: {
                value: false,
                inputType: CHECKBOX_INPUT
            }
        };
        tableContentsCopy.push(newItem);
  changeData(tableContentsCopy, stateKey);
    
    }

 

    

    const keyDownSubmit = (value: any) => {
        if (value.key === 'Enter' && value.target.value !== "") {
            handleSearchWorks();
        }
    }

    
    const setHasOpenWorkFlow = (option: string) => {
            let openWorkflowsearch: boolean = null;
            if (option.length > 0)
                switch (option) {
                    case DONOTCARE_ABOUTWORKFLOWS:
                        openWorkflowsearch = null;
                        break;
                    case HASOPEN_WORKFLOWS:
                        openWorkflowsearch = true;
                        break;
                    case WITHOUTOPEN_WORKFLOWS:
                        openWorkflowsearch = false;
                        break
                }
                setData( openWorkflowsearch ? { ...data, hasOpenWorkflow: openWorkflowsearch } : { ...data, hasOpenWorkflow: null });
        }

 
    const renderSearchFields = () => {

                    let filteredSearchFields = searchViewData.fields.filter(
                        (searchField: IRepertoireField ) =>
                            searchField.componentInstance === SEARCH_VIEW_WORKS
                    );


        const filteredSearchFieldsMapper = (searchField: IRepertoireField, index: number) => {
        let reactElement = null;
                  if ((searchField.fieldType === 'text' || searchField.fieldType === 'integer' || searchField.fieldType === 'decimal')) {
                            reactElement =
                                    <SizedTextDataInput
                                        fieldType={searchField.fieldType}
                                        useEnterSubmit={true}
                                        label={searchField.data}
                                        fieldName={searchField.name}
                                        changeData={changeTextData}
                                        handleKeyDown={keyDownSubmit}
                                        value={data[searchField.name]}
                                        readOnly={false}
                                        isHidden={searchField.hidden}
                                        key={`${index}`}
                                    />
                                }

                                      if (searchField.fieldType === 'boolean' && searchField.name === SEARCH_VIEW_HAS_OPEN_WORKFLOW && originWork?.dataSource != INTRAY) {
                                                reactElement =
                                                        <SizedRadiobuttonDataInput
                                                        key={`${index}`}
                                                            selectedValue={data[searchField.name] === null ?
                                                                DONOTCARE_ABOUTWORKFLOWS :
                                                                data[searchField.name] === true ? HASOPEN_WORKFLOWS : WITHOUTOPEN_WORKFLOWS}
                                                            onSelectionChange={setHasOpenWorkFlow}
                                                            radioName="hasOpenWorkFlow"
                                                            title={searchField.data}
                                                            options={[
                                                                { desc: ComponentsHelper.getFieldValueByName("doNotCareAboutWorkflowsDesc", searchViewData.fields), code: DONOTCARE_ABOUTWORKFLOWS },
                                                                { desc: ComponentsHelper.getFieldValueByName("hasOpenWorkflowsDesc", searchViewData.fields), code: HASOPEN_WORKFLOWS },
                                                                { desc: ComponentsHelper.getFieldValueByName("withoutOpenWorkflowsDesc", searchViewData.fields), code: WITHOUTOPEN_WORKFLOWS }
                                                            ]}
                                                        />
                                      }

                                      return reactElement;
                                  } 

                                    return  filteredSearchFields.map(filteredSearchFieldsMapper)
    }

    const renderSearchResults = () => {
        if (searchSuccessful &&
            ((!!worksSearchResults && worksSearchResults.length <= 0))) {
            return (
                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                        No results found.
                    </div>
                </div>
            )
        } else if (worksSearchResults && worksSearchResults.length >= 1) {
                    return (<div className="row">
                            <div className="row" key={expandedWorkResults.length}>
                                            <SelectionTable
                                                key={0}
                                                searchResultsTableData={searchResultsTableData}
                                                tableContents={worksSearchResults}
                                                componentInstance={SEARCH_VIEW_WORKS}
                                                sourceItem={originWork}
                                                updateMatchingWork={handleAddNewMatchingWork}
                                                hideModal={hideModal}
                                                lookupValues={lookupValues}
                                                expandResult={(workResult) => handleExpandSearchResult(workResult)}
                                                expandAllResults={handleExpandAllSearchResults}
                                                expandAll={isSearchExpandAllClicked}
                                                expandedResults={expandedSearchResults}
                                                openInSplitScreen={openInSplitScreen}
                                                indexOfFirstResult={indexOfFirstResult}
                                                indexOfLastResult={indexOfLastResult}
                                                resultsPerPage={resultsPerPage}
                                                currentPage={currentPage}
                                                updatePagination={updatePagination}
                                                repertoireSection={SEARCH_VIEW_WORKS}
                                            />
                                        </div>
                        </div>)

    }}


    const handleToggleWorkIntrayOpenSearch = () => {
        setIsWorkIntraySearchOpen(!isWorkIntraySearchOpen)
    } 
    return (
        <>
        <div className="row">
        <div style={{ background: '#f5f5f5', width: '98%', margin: '16px', padding: '7px' }}>
            <div className="UsageMaintenanceMatchingWorksToolbar">
                      <div className="toolbarButton" key={'toolbarButton'}>
                                <div className={["toolbarButtonContainer"].join(' ')} style={{pointerEvents: 'auto'}}>
                                    <IconTextButton
                                        text={isWorkIntraySearchOpen ? "Close Search Work To Match" : "Open Search Work To Match"}
                                        icon={Search20Regular}
                                        onClick={handleToggleWorkIntrayOpenSearch}
                                        disabled={false}
                                    />
                                </div>
                            </div>
                            </div>
            </div>
            </div>

            {isWorkIntraySearchOpen && <div className="searchView">
                <div key='searchFields' className="row flexWrapRow paddingVeryLarge">                   
                    {renderSearchFields()}
                </div>
                
                <div key='action' className="row">
                    <div className="form-group col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-6 col-sm-push-6 col-xs-12 col-xs-push-0">
                        <ActionButton buttonText="Search" buttonAction={handleSearchWorks}  />
                    </div>
                </div>
                <div key='results'>
                    {renderSearchResults()}
                </div>
                </div>}
                </>
    )
}



export default connect(
    (state: IAppState, props: any) => ({
        worksPageData: state.repertoire.componentData.WorksPage,
        searchViewData: state.repertoire.componentData.SearchView,
        searchResultsTableData: state.repertoire.componentData.SearchResultsTable,
        dataSource: state.repertoire.dataSource,
        worksSearchResults: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab] === undefined ? undefined : state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].worksSearchResult,
        expandedWorkResults: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab] && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].expandedWorkResults,
        expandAll: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab] && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].expandAll,
        indexOfFirstResult: state.repertoire.resultsPerPage.filter(x => x.repertoireSection === 'works')[0].indexOfFirstResult,
        indexOfLastResult: state.repertoire.resultsPerPage.filter(x => x.repertoireSection === 'works')[0].indexOfLastResult,
        resultsPerPage: state.repertoire.resultsPerPage.filter(x => x.repertoireSection === 'works')[0].resultsPerSection,
        currentPage: state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab] && state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].currentPage ? state.repertoire.panes[props.paneIndex].tabs[state.repertoire.panes[props.paneIndex].activeTab].currentPage : undefined,
        lookupValues: state.lookupEntities,
    }),
    dispatch => ({
        updateMatchingWork: (workID: number, work: IWorksSearchResult) => dispatch<any>(updateMatchingWork(workID, work)),
        hideModal: () => dispatch(hideModal()),
        searchWorks: (query: IWorksSearchQuery, modalOpen: boolean, lookups: ILookupDictionary) =>
            dispatch<any>(searchWorksThunk(query, false, lookups)),
        expandWorkResult: (workResult: number) => dispatch<any>(expandWorkResult(workResult)),
        expandAllResults: () => dispatch<any>(expandAllResults()),
        updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => dispatch<any>(updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection)),
        resetPagination: (repertoireSection: string) => dispatch(resetPagination(repertoireSection)),
        updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => dispatch<any>(updateUserPreferencesThunk(allResultsPerPage, activeAccordions, newActiveAccordionName, accordionExpanded, componentName, indexOfFirstResult, indexOfLastResult, resultsPerPage, repertoireSection)),
    }))(MatchingRepertoireWorksSearchSection);